import nav from './ru/nav.json'
import labels from './ru/labels.json'
import errors from './ru/errors.json'
import messages from './ru/messages.json'
import pl from './ru/placeholders.json'
import orders from './ru/orders.json'
import order from './ru/order.json'
import knowledge from './ru/knowledge.json'
import rbidos_access from './ru/rbidos_access.json'
import som from './ru/som.json'
import common from './ru/common.json'
import start_page from './ru/start_page.json'
import modals from './ru/modals.json'
import news from './ru/news.json'
import address from './ru/address.json'
import company from './ru/company.json'
import coliseum from './ru/coliseum.json'
import cabinet from './ru/cabinet.json'
import acts from './ru/acts.json'
import setting from './ru/setting.json'
import survey from './ru/survey.json'
import recommendations from './ru/recommendations.json'
import profile from './ru/profile.json'
import notification from './ru/notification.json'
import popup_page from './ru/popup_page.json'
import landing from './ru/landing.json'
import blockGroupProduct from './ru/blockGroupProduct.json'
import cabinetPro from './ru/cabinetPro.json'
import cabinetProError from './ru/cabinetProError.json'
import lib from './ru/lib.json'
import referenceBook from './ru/reference_book.json'
import pp from './ru/pp.json'
import broker from './ru/broker.json'
import partnerPayment from './ru/partner_payment.json'
import lead from './ru/lead.json'
import auth from './ru/auth.json'
import notify_messages from './ru/notify_messages.json'
import validators from './ru/validators.json'
import fake_responses from './ru/fake_responses.json'
import partner from './ru/partner.json'
import drs_fake_responses from './ru/drs_fake_responses.json'
import online_order_fields from './ru/online_order_fields.json'
import rbidos_load_company from './ru/rbidos_load_company.json'

export default {
	nav,
	labels,
	errors,
	messages,
	pl,
	orders,
	order,
	knowledge,
	rbidos_access,
	som,
	common,
	modals,
	start_page,
	news,
	address,
	coliseum,
	cabinet,
	company,
	acts,
	setting,
	survey,
	profile,
	notification,
	popup_page,
	blockGroupProduct,
	landing,
	recommendations,
	cabinetPro,
	cabinetProError,
	lib,
	pp,
	referenceBook,
	broker,
	partnerPayment,
	lead,
	auth,
	notify_messages,
	validators,
	fake_responses,
	drs_fake_responses,
	partner,
	online_order_fields,
	rbidos_load_company,
}
